import Checkbox from './dist/index.es'

export default Checkbox
